import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createModelAction } from '../../../redux/actions/modelsActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';
import ModelForm from '../forms/ModelForm';

const CreateModelModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const brandId = useSelector((state) => state.models.brand?.id);

  const onSubmit = async (data) => {
    setLoading(true);
    await dispatch(createModelAction(data, brandId));
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Додати модель'}
      loading={loading}
      onClose={onModalClose}
      body={<ModelForm readOnly={false} onSubmit={onSubmit} loading={loading} />}
      actionButton={
        <Button type={'submit'} disabled={loading} variant={'primary'} formId={'model-form'} children={'Зберегти'} />
      }
    />
  );
};

export default CreateModelModal;
